"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var getDomain = function (email) { return email.slice(email.indexOf('@') + 1); };
function sanitizeTraits(traits) {
    var _a;
    traits = traits || {};
    var licensesProperties = (_a = traits.licenses) === null || _a === void 0 ? void 0 : _a.reduce(function (accumulator, license) {
        var _a;
        return (__assign(__assign({}, accumulator), (_a = {}, _a["license_".concat(license.productType)] = license.type, _a)));
    }, {});
    // Spec for these properties: https://wiki.autodesk.com/pages/viewpage.action?pageId=664366824
    return __assign({ oxygen_user_id: traits.autodeskId || traits.oxygenId, oxygen_analytics_id: traits.analyticsId, email: typeof traits.email === 'string' ? traits.email : undefined, domain: typeof traits.email === 'string'
            ? getDomain(traits.email).toLowerCase()
            : undefined, is_employee: traits.email &&
            typeof traits.email === 'string' &&
            (traits.email.indexOf('@autodesk.com') > 0 ||
                traits.email.indexOf('@plangrid.com') > 0), name: typeof traits.name === 'string' &&
            traits.name
                .split(' ')
                .map(function (n) { return n.charAt(0); })
                .join('')
                .toUpperCase() }, licensesProperties);
}
exports.default = sanitizeTraits;
